import React, { Component } from "react";
import { prerollTag } from "../../static/ads"
import "./HolaPlayer.scss"
import { GA_Event } from "../Analytics/Analytics";


class HolaPlayer extends Component {
    constructor() {
        super();
        this.OnVideoClick = this.OnVideoClick.bind(this);

        this.state = {
            isPlayerClicked: false
        }
    }
    componentDidMount() {
        window.hola_player({
            player: `#${this.props.id}`,
            ads: { adTagUrl: prerollTag },
        });
        window.spark_conf = {
            enable_events: true,
            debug: true,
        };
        window.addEventListener('spark_any', function (data) {
            debugger;
            console.log("asdasasd");
        });
        var id = this.props.id;
        setTimeout(() => {
            document.getElementById(`${id}`).addEventListener("click", () => this.OnVideoClick());
            document.getElementById(`${id}`).addEventListener("touchstart", () => this.OnVideoClick());
        }, 1000);

    }

    OnVideoClick() {
        if (!this.state.isPlayerClicked) {
            var title = this.props.title;
            GA_Event("Video_Play", title);
            this.setState({
                isPlayerClicked: true
            })
        }

    }

    render() {
        return (
            <video id={this.props.id} preload="none" className="video-js vjs-default-skin" controls poster={this.props.poster}>
                <source src={this.props.src} />
            </video>
        );
    }
}

export default HolaPlayer;


// WEBPACK FOOTER //
// ./src/Components/HolaPlayer/HolaPlayer.jsx